/**
 *
 * @module lineItem
 *
 */

import Check from 'check-types';
import Services from './../services/entry';

const LineItemAttribute = Services.Commerce.LineItemAttribute;

const InvalidArgumentException = Services.Exception.InvalidArgumentException;

const {
    array,
    nonEmptyString
} = Check.assert;

/**
 *
 * @class LineItem
 * @desc Description of an item to be submitted for purchase.
 *
 */
export default class LineItem {

    /**
     *
     * @param {String} sku
     * @param {SDK.Services.Commerce.LineItemAttribute} attributes
     * @throws {InvalidArgumentException}
     *
     */
    constructor(sku, attributes) {

        const errorMessage = {
            ctor: 'LineItem(sku, attributes)',
            get sku() {
                return `${this.ctor} sku should be a String with length`;
            },
            get attributes() {
                return `${this.ctor} needs SDK.Services.Commerce.LineItemAttribute instance`;
            }
        };

        nonEmptyString(sku, errorMessage.sku, InvalidArgumentException);
        array.of.instanceStrict(attributes, LineItemAttribute, errorMessage.attributes, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.sku = sku;

        /**
         *
         * @access public
         * @type {Array<SDK.Services.Commerce.LineItemAttribute>}
         *
         */
        this.attributes = attributes;

    }

}



// WEBPACK FOOTER //
// ./src/commerce/lineItem.js